import { useState, useEffect } from 'preact/hooks';
/**
 * Returns true when the viewport width is below the given breakpoint.
 * Defaults to 640px (Tailwind `sm`).
 */
export function useIsMobile(breakpoint = 640) {
    const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth < breakpoint);
    useEffect(() => {
        const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
        const handler = (e) => setIsMobile(e.matches);
        setIsMobile(mql.matches);
        mql.addEventListener('change', handler);
        return () => mql.removeEventListener('change', handler);
    }, [breakpoint]);
    return isMobile;
}
